import {
  memo, useCallback, useEffect, useState,
} from 'react';

import MediaPlayer from 'app/lib/MediaPlayer';
import Gift from 'app/components/common/gift/Gift';
import ModalCashAvailableList from 'app/components/common/gift/elements/ModalCashAvailableList';
import { useFlipbookContext } from 'app/components/common/flipbook/lib/hooks';
import { IPageGift as IPageGiftData, VirtualGiftType } from 'app/store/nodes/card/interfaces';
import { useDispatcher, useSelector } from 'app/store/utils/redux/hooks';

type PageVirtualGiftProps = {
  data?: IPageGiftData<VirtualGiftType>,
};

const PageVirtualGift = (props: PageVirtualGiftProps) => {
  const {
    data,
  } = props;

  const isChanging = useSelector((state) => state?.gift?.cash.meta.isChanging);
  const [isChooseOpened, setChooseOpened] = useState(false);
  const { controller } = useFlipbookContext();
  const actions = useDispatcher();

  const handleGiftClick = useCallback(() => {
    if (!data?.items?.gift?.isCardsnacksCash) {
      actions.gift.setOpenGift();
      return;
    }
    if (!data?.items?.gift?.amount) {
      return;
    }
    controller?.updateConfig({
      enabledFlip: false,
    });
    setChooseOpened(true);
    actions.gift.cashLoadData(data?.items?.gift?.amount, data?.items?.gift.id);
    MediaPlayer.pauseAll('gift-cash');
  }, [actions.gift, controller, data?.items?.gift?.amount, data?.items?.gift?.isCardsnacksCash]);

  const handleGiftTermsClick = useCallback(() => {
    if (data?.items?.gift?.terms) {
      actions.gift.setOpenGiftTerms();
    }
  }, [actions.gift, data?.items?.gift?.terms]);

  const handleCashAvailableListClose = useCallback(() => {
    setChooseOpened(false);
    MediaPlayer.resumeAll('gift-cash');
  }, []);

  const handleCashAvailableListChoose = useCallback((id: number) => {
    actions.gift.cashSelectCard(id);
    handleCashAvailableListClose();
    MediaPlayer.resumeAll('gift-cash');
  }, [actions.gift, handleCashAvailableListClose]);

  const handleCashAvailableListClosed = useCallback(() => {
    controller?.updateConfig({
      enabledFlip: true,
    });
  }, [controller]);

  useEffect(() => {
    actions.hint.reshow(5000);
  }, [actions.hint]);

  if (
    !data?.items?.gift?.image
    || !data?.items?.gift?.currency
    || !data?.items?.gift?.amount
    || !data?.items?.gift?.platform
  ) {
    return null;
  }

  const buttonText = data?.items?.gift?.isCardsnacksCash ? 'Choose gift card' : 'open';

  return (
    <>
      <Gift
        id={data?.items?.gift?.id}
        type={data?.items?.gift?.type}
        isCardsnacksCash={data?.items?.gift?.isCardsnacksCash}
        source={data?.items?.gift?.source}
        image={data?.items?.gift?.image}
        currency={data?.items?.gift?.currency}
        amount={data?.items?.gift?.amount}
        platform={data?.items?.gift?.platform}
        expiration={data?.items?.gift?.expiration}
        buttonText={buttonText}
        onButtonClick={handleGiftClick}
        onTermsClick={handleGiftTermsClick}
        isLoading={isChanging}
        hasTerms={Boolean(data?.items?.gift?.terms)}
      />
      <ModalCashAvailableList
        isOpened={isChooseOpened}
        amount={data?.items?.gift?.amount}
        onClose={handleCashAvailableListClose}
        onChoose={handleCashAvailableListChoose}
        onClosed={handleCashAvailableListClosed}
      />
    </>
  );
};

export default memo(PageVirtualGift);
